<a [routerLink]="url" class="sidebar-ad-placeholder">
  <img [attr.fetchpriority]="'auto'" [loading]="'lazy'" [ngSrc]="imgSrc" alt="default ad" height="600" width="320">
</a>
